export const ROLE_LABELS = {
  citizen: "Citizen",
  pi: "Police Inspector",
  acp: "ACP",
  dcp: "DCP",
  additional_cp: "Additional CP",
  control_room: "Police Control Room",
  municipal_commissioner: "Municipal Commissioner",
  divisional_commissioner: "Divisional Commissioner",
  collector: "Collector",
  commissioner_of_police: "Commissioner of Police",
  admin: "Admin",
};

export const VIEWER_ROLES = [
  "municipal_commissioner",
  "divisional_commissioner",
  "collector",
  "commissioner_of_police",
  "admin",
];

export const OFFICER_ROLES_FOR_ADMIN = [
  "pi", "acp", "dcp", "additional_cp", "control_room",
  "municipal_commissioner", "divisional_commissioner",
  "collector", "commissioner_of_police", "admin",
];

export const STATUS_LABELS = {
  submitted: "Submitted",
  assigned: "Assigned",
  in_progress: "In Progress",
  attended: "Attended by PI",
  resolved: "Resolved",
  rejected: "Rejected (Fake)",
  escalated: "Escalated",
};

export const STATUS_COLORS = {
  submitted: "bg-slate-100 text-slate-800 border-slate-300",
  assigned: "bg-blue-50 text-blue-800 border-blue-300",
  in_progress: "bg-amber-50 text-amber-900 border-amber-300",
  attended: "bg-indigo-50 text-indigo-900 border-indigo-300",
  resolved: "bg-emerald-50 text-emerald-900 border-emerald-300",
  rejected: "bg-slate-100 text-slate-700 border-slate-400",
  escalated: "bg-red-50 text-red-800 border-red-300",
};

export const LEVEL_LABELS = {
  ps: "Police Station",
  acp: "ACP",
  dcp: "DCP",
};

// SLA minutes per level (must match backend escalation.py)
export const LEVEL_SLA_MINUTES = { ps: 30, acp: 30, dcp: 30 };

export const NOISE_SOURCES = [
  { key: "loudspeaker", label: "Loudspeaker / Public Address" },
  { key: "vehicle", label: "Vehicle / Traffic Horn" },
  { key: "construction", label: "Construction / Machinery" },
  { key: "dj", label: "DJ / Loud Music" },
  { key: "industrial", label: "Industrial / Factory" },
  { key: "firecrackers", label: "Firecrackers" },
  { key: "other", label: "Other" },
];

export const roleHomePath = (role) => {
  if (role === "citizen") return "/citizen";
  if (role === "pi") return "/pi";
  if (role === "acp") return "/acp";
  if (role === "dcp") return "/dcp";
  if (role === "additional_cp") return "/additional-cp";
  if (role === "control_room") return "/control-room";
  if (role === "admin") return "/admin";
  if (VIEWER_ROLES.includes(role)) return "/dashboard";
  return "/";
};
